import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const AKBetsBrandIcon = observer(
    'AKBetsBrandIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='32'
            height='34'
            viewBox='0 0 32 34'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g>
                <g>
                    <path
                        d='M12.5344 23.0048L11.8721 21.1758H7.14345L6.46242 23.0048H2.77356L7.60965 10.9941H11.4059L16.242 23.0048H12.5344ZM9.52552 14.6866L8.19995 18.2903H10.8323L9.52447 14.6866H9.52552Z'
                        fill='#E8530E'
                    />
                    <path
                        d='M25.0705 23.0048L22.2942 18.8635L20.5212 20.9973V23.0048H17.0826V10.9941H20.5212V16.1742L24.8921 10.9941H28.7969L24.5344 16.1575L29.2265 23.0059H25.0715L25.0705 23.0048Z'
                        fill='#E8530E'
                    />
                </g>
            </g>
        </SvgElement>
    )
);
